export const ACCOUNT_LIST_ENDPOINT = 'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default';
export const BULK_BALANCE_ALERTS_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/alerts/balance/preferences';
export const WEEKLY_BALANCE_ALERT_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/alerts/balance/preferences/weekly';
export const USER_DETAILS_ENDPOINT = 'PAASBaseUrl/ibapi/v2/user/details';
export const BALANCE_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/accountId/alerts/balance/preferences';
export const UPDATE_WEEKLY_BALANCE_ALERT_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/{account_id}/alerts/balance/preferences/weekly';
export const GET_SWEEPS_LIST_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/accountId/sweeps';
export const GET_CMA_DETAILS_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/{account_id}/alerts/payment/preference';
export const SWEEPS_EDIT_DELETE_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/accountId/sweeps/sweepId';
export const BULK_PROJECTION_ALERT_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/projection/alerts';
export const PROJECTION_BALANCE_ALERT_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/accountId/projection/alerts';
export const BULK_TRANSACTION_ALERTS_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/accountId/alerts/transaction/debit/preferences';
export const B_TRANSACTION_ABROAD_URL = 'https://www.youandb.co.uk/help/find-answers/';
export const CB_TRANSACTION_ABROAD_URL =
  'https://secure.cbonline.co.uk/personal/travel/using-your-cards-abroad/';
export const YB_TRANSACTION_ABROAD_URL =
  'https://secure.ybonline.co.uk/personal/travel/using-your-cards-abroad/';
export const INCOMING_TRANSACTION_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/accountId/alerts/transaction/credit/preferences';
export const GET_ACCOUNT_DETAILS_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/{account_id}';
export const GET_ARRANGED_OVERDRAFT_ALERT_ENDPOINT =
  'PAASBaseUrl/ibapi/v2/banks/bank_id/accounts/default/{account_id}/alerts/preferences';
export const VM_TRANSACTION_ABROAD_URL =
  'https://uk.virginmoney.com/current-accounts/pca/questions-and-answers/';
/* eslint-enable max-len */
